import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 2,
      cacheTime: 1000 * 5,
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
